import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import assign from 'domkit/appendVendorPrefix';
import { SIZE_TO_VAL, SIZES } from './spinner.sizes';
import { animationNameEven, animationNameOdd } from './spinner.animation';
import './style.scss';
const LOADER_COLOR = '#000';
const ANIMATION_FILL_MODE = 'both';
class Loader extends PureComponent {
  constructor() {
    super(...arguments);
    this.getAnimationStyle = i => {
      const animation = [i % 2 === 0 ? animationNameEven : animationNameOdd, '1s', '0s', 'infinite', 'cubic-bezier(.15,.46,.9,.6)'].join(' ');
      return {
        animation,
        animationFillMode: ANIMATION_FILL_MODE
      };
    };
    this.getStyle = i => assign(this.getBallStyle(), this.getAnimationStyle(i), {
      display: 'inline-block'
    });
  }
  getBallStyle() {
    const {
      size,
      margin,
      verticalAlign
    } = this.props;
    const sizeVal = SIZE_TO_VAL[size];
    return {
      backgroundColor: LOADER_COLOR,
      width: sizeVal,
      height: sizeVal,
      borderRadius: '100%',
      margin,
      verticalAlign
    };
  }
  render() {
    const {
      className,
      loading,
      id
    } = this.props;
    if (loading) {
      return /*#__PURE__*/React.createElement("div", {
        id: id,
        className: "loader-position ".concat(className)
      }, /*#__PURE__*/React.createElement("div", {
        style: this.getStyle(1)
      }), /*#__PURE__*/React.createElement("div", {
        style: this.getStyle(2)
      }), /*#__PURE__*/React.createElement("div", {
        style: this.getStyle(3)
      }), /*#__PURE__*/React.createElement("div", {
        style: this.getStyle(4)
      }), /*#__PURE__*/React.createElement("div", {
        style: this.getStyle(5)
      }));
    }
    return null;
  }
}
Loader.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  loading: PropTypes.bool,
  margin: PropTypes.string,
  size: PropTypes.string,
  verticalAlign: PropTypes.string
};
Loader.defaultProps = {
  className: '',
  loading: true,
  margin: '2px',
  size: SIZES.MEDIUM,
  verticalAlign: ''
};
export default Loader;